const AnalyseStatistics = ()=> import('@/views/main/report/analyseStatistics/AnalyseStatistics.vue')
export default {
  path: '/main/report/analyseStatistics',
  name: 'AnalyseStatistics',
  component: AnalyseStatistics
}
